module.exports = __webpack_public_path__ + "img/whats-32.7521d64f.svg";